import { Link } from 'react-router-dom';

export const NotFoundPage = () => {
  return (
    <section className="relative h-screen w-full">
      <div className="bg-cover bg-center bg-wizard bg-no-repeat absolute top-0 right-0 bottom-0 left-0">
        <h2 className="mt-64 font-poppins font-normal text-whiteMagic text-xl md:text-3xl text-center leading-7 tracking-wider">
          This way doesnt exist. Return to{' '}
          <Link className="text-hover hover:text-borderColor duration-300" to="/">
            the Beginning
          </Link>
        </h2>
      </div>
    </section>
  );
};
